import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SplashScreenProvider {

    private readonly _show = new BehaviorSubject<boolean>(false);
    public readonly show$ = this._show.asObservable();

    private readonly _loading = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this._loading.asObservable();

    private _loadingTimeout: any;

    async show() {
        this._show.next(true);
    }

    async showWithLoading(loadingTimeout = 0) {
        this._show.next(true);
        this._loadingTimeout = loadingTimeout;

        setTimeout(async () => {
            const hasInternetConnection = (await Network.getStatus()).connected;
            if (hasInternetConnection) {
                this._loading.next(true);
            }
        }, loadingTimeout);
    }

    hide() {
        clearTimeout(this._loadingTimeout);

        this._loading.next(false);
        this._show.next(false);;
    }
}
